import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';

// eslint-disable-next-line
import icons from '@fortawesome/fontawesome-free-solid';

import App from './components/App/App';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

if (module.hot) {
  module.hot.accept('./components/App/App', () => {
    ReactDOM.render((
      <BrowserRouter>
        <App />
      </BrowserRouter>
    ), document.getElementById('root'))
  })
}



// WEBPACK FOOTER //
// ./src/index.js